export function formOverlayEvents() {
	const triggers = Array.from(
		document.querySelectorAll('[data-ilawyer-button^="form-overlay"]')
	);
	if (!triggers.length) {
		return;
	}

	async function firstClick(e) {
		triggers.forEach((trigger) => trigger.removeEventListener("click", firstClick));
		try {
			const { initFormOverlay } = await import("./form-overlay.js");
			const openFormOverlay = initFormOverlay();
			if (typeof openFormOverlay === "function") {
				openFormOverlay(e);
			}
		} catch (err) {
			console.error("Failed to load module:", err);
		}
	}

	triggers.forEach((trigger) => trigger.addEventListener("click", firstClick));
}
